import { render } from "./CallActionServiceSolo.vue?vue&type=template&id=5128954c&scoped=true"
import script from "./CallActionServiceSolo.vue?vue&type=script&lang=js"
export * from "./CallActionServiceSolo.vue?vue&type=script&lang=js"

import "./CallActionServiceSolo.vue?vue&type=style&index=0&id=5128954c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5128954c"]])

export default __exports__